// client.js

var axios = require('axios');

var axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_SERVER_URL,
    /* other custom settings */
});

axiosInstance.interceptors.request.use(function (config) {
    const tokens = JSON.parse(localStorage.getItem("user"));
    if(tokens){
        config.headers.Authorization =  `Bearer ${tokens["idToken"]}`;
    }
    return config;
});

module.exports = axiosInstance;